import getSelectedTableView from "../utils/getSelectedTableView";
import { resolveRowKeysFromTabItemId } from "../utils/getEffectiveRowKeys";
import getListViewStore from "../store/Store";
import { owaComputedFn } from "owa-computed-fn";
import { isGlobalFeatureEnabled } from "owa-feature-flags";
import { getActiveSecondaryReadingPaneTabItemId } from "owa-tab-store";

const getComputedSelectedRowKeysSize: () => number = owaComputedFn(function getComputedSelectedRowKeysSize(): number {
    if (isGlobalFeatureEnabled("mon-ribbon-secondary-rp-activation")) {
        const secondaryTabItemId = getActiveSecondaryReadingPaneTabItemId();
        if (secondaryTabItemId) {
            // selectedRowKeys in the SRP item's origin table is cleared when the user
            // navigates away (loadTableViewFromTableQuery resets selection on the old
            // table). resolveRowKeysFromTabItemId reads rowIdToRowKeyMap instead, which
            // persists as long as the table is in memory.
            const tableView = getSelectedTableView(true /* shouldGetEffectiveTableView */);
            if (tableView) {
                const rowKeys = resolveRowKeysFromTabItemId(secondaryTabItemId, tableView);
                if (rowKeys.length > 0) {
                    return rowKeys.length;
                }
            }
        }
    }
    return getSelectedTableView()?.selectedRowKeys.size ?? 0;
});
export default getComputedSelectedRowKeysSize;

export const getComputedSelectedRowKeysSizeForTable: (tableViewId: string) => number = owaComputedFn(function getComputedSelectedRowKeysSizeForTable(tableViewId: string): number {
    return getListViewStore().tableViews.get(tableViewId)?.selectedRowKeys.size ?? 0;
});
